import { html, strMap } from 'fxjs/es';
import { UtilImageS } from '../../../../../../Util/Image/S/Function/module/UtilImageS.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';

const play_icon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 96 96" fill="none">
    <g clip-path="url(#clip0_6347_36516)">
      <circle cx="48" cy="48" r="48" fill="black" fill-opacity="0.4" />
      <path d="M35.5557 65.7777V30.2222L64.0001 48.5079L35.5557 65.7777Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_6347_36516">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

const nessBannerVideo = ({ format, id, thumbnail_url, content_url }) => {
  return html`
    <div data-id="${id}" data-format="${format}" class="ness-crew-billboard__banner-item swiper-slide">
      <video
        class="video-js vjs-default-skin"
        data-id="${id}"
        data-format="${format}"
        src="${content_url}"
        playsinline
      ></video>
      <div class="ness-crew-billboard__banner-item-thumbnail">
        <img
          src="${UtilImageS.getResizedUrl({
            url: thumbnail_url,
            format: 'webp',
            width: 750,
          })}"
          alt="thumbnail"
        />
        <div class="ness-video-big-play-button">${play_icon}</div>
      </div>
    </div>
  `;
};

const nessBannerYoutube = ({ format, id, thumbnail_url, content_url }) => {
  return html`
    <div data-id="${id}" data-format="${format}" class="ness-crew-billboard__banner-item swiper-slide">
      <video
        class="video-js vjs-default-skin"
        data-id="${id}"
        data-format="${format}"
        src="${content_url}"
        width="100%"
        height="100%"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen="false"
      ></video>
      <div class="ness-crew-billboard__banner-item-thumbnail">
        <img src="${thumbnail_url}" alt="thumbnail" />
        <div class="ness-video-big-play-button">${play_icon}</div>
      </div>
    </div>
  `;
};

const nessBannerImage = ({ format, url, content_url }) => {
  const target = url?.includes('http') ? '_blank' : '_self';
  return html`
    <div data-format="${format}" class="ness-crew-billboard__banner-item swiper-slide">
      <a href="${url}" class="ness-crew-billboard__banner-anchor" target="${target}">
        <img
          class="ness-crew-billboard__banner-image"
          src="${UtilImageS.getResizedUrl({
            url: content_url,
            format: 'webp',
            width: 750,
          })}"
          alt=""
        />
      </a>
    </div>
  `;
};

const bannerItem = (banner) => {
  const { format } = banner;
  if (format === 'video') {
    return nessBannerVideo(banner);
  }

  if (format === 'youtube') {
    return nessBannerYoutube(banner);
  }

  return nessBannerImage(banner);
};

export const crewBillboard = ({ plus_crew, banners, is_mobile, crew_like }) => {
  const bg_img = (() => {
    if (!is_mobile && plus_crew.pc_cover_image) {
      return html`<img
        class="ness-crew-billboard__bg"
        src="${UtilImageS.getResizedUrl({
          url: plus_crew.pc_cover_image,
          format: 'webp',
          height: '1280',
        })}"
        alt="background"
      />`;
    }

    if (is_mobile && plus_crew.mo_cover_image) {
      return html`<img
        class="ness-crew-billboard__bg"
        src="${UtilImageS.getResizedUrl({
          url: plus_crew.mo_cover_image,
          format: 'webp',
          height: '1280',
        })}"
        alt="background"
      />`;
    }

    return '';
  })();

  return html`
    <div class="ness-crew-billboard__wrapper">
      <div class="ness-crew-billboard__bg-wrapper">
        <div class="ness-crew-billboard__bg-dim"></div>
        ${bg_img}
      </div>
      <div class="ness-crew-billboard">
        <div class="ness-crew-billboard__info">
          <h3 class="ness-crew-billboard__logo">${plus_crew.brand_name || plus_crew.name}</h3>
          <div class="ness-crew-billboard__title-wrapper">
            <h2 class="ness-crew-billboard__title">${plus_crew.brand_title || plus_crew.name}</h2>
            <div class="ness-crew-billboard__link-wrapper">
              ${plus_crew.official_url
                ? html`<a class="ness-crew-billboard__link" href="${plus_crew.official_url}" target="_blank">
                    ${NessCoreTmplS.linkLogoButton()}
                  </a>`
                : ''}
              ${plus_crew.fb_url
                ? html`<a class="ness-crew-billboard__link" href="${plus_crew.fb_url}" target="_blank">
                    ${NessCoreTmplS.fbLogoButton()}
                  </a>`
                : ''}
              ${plus_crew.ig_url
                ? html`<a class="ness-crew-billboard__link" href="${plus_crew.ig_url}" target="_blank">
                    ${NessCoreTmplS.instagramLogoButton()}
                  </a>`
                : ''}
              ${plus_crew.yt_url
                ? html`<a class="ness-crew-billboard__link" href="${plus_crew.yt_url}" target="_blank">
                    ${NessCoreTmplS.youtubeLogoButton()}
                  </a>`
                : ''}
              ${plus_crew.tw_url
                ? html`<a class="ness-crew-billboard__link" href="${plus_crew.tw_url}" target="_blank">
                    ${NessCoreTmplS.xLogoButton()}
                  </a>`
                : ''}
            </div>
          </div>
          ${plus_crew.brand_desc
            ? html`
                <div class="ness-crew-billboard__desc-wrapper">
                  <div class="ness-crew-billboard__desc" data-see_more="false">
                    ${(plus_crew.brand_desc || '').replace(/\n/g, '<br />')}
                  </div>
                </div>
                <div class="ness-crew-billboard__desc-more-wrapper">
                  <div class="ness-crew-billboard__desc-more" data-see_more="false">See More</div>
                </div>
              `
            : ''}
          <button
            type="button"
            class="ness-crew-billboard__favorite"
            data-ghost_store_id="${plus_crew.ghost_store_id}"
            data-active="${crew_like?.activated || false}"
          >
            <span class="ness-crew-billboard__favorite-icon">${NessCoreTmplS.nessHeartIcon()}</span>
            <span class="ness-crew-billboard__favorite-text">${UtilS.commify(crew_like.count)}</span>
          </button>
        </div>
        ${banners.length
          ? html`
              <div class="ness-crew-billboard__banner-wrapper">
                <div class="ness-crew-billboard__banner swiper-container">
                  <div class="ness-crew-billboard__banner-media swiper-wrapper">
                    ${strMap(bannerItem, banners)}
                  </div>
                </div>
                ${is_mobile || banners.length <= 1
                  ? ''
                  : html`
                      <div class="ness-crew-billboard__banner-pagination">
                        <div class="ness-crew-billboard__banner-pagination-info">
                          <span class="ness-crew-billboard__banner-pagination-index">1</span><span>/</span
                          ><span>${banners.length}</span>
                        </div>
                        <div class="ness-crew-billboard__banner-pagination-control">
                          <div class="ness-crew-billboard__banner-pagination-button pagination-button__left">
                            ${NessCoreTmplS.nessLeftIcon()}
                          </div>
                          <div class="ness-crew-billboard__banner-pagination-button pagination-button__right">
                            ${NessCoreTmplS.nessRightIcon()}
                          </div>
                        </div>
                      </div>
                    `}
              </div>
            `
          : ''}
      </div>
    </div>
  `;
};
